import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { TrainingCourseSection } from 'app/_models/training/training-course-section.model';
import { TrainingCourseSectionState } from 'app/_models/training/training-course-section-state';
import { TrainingCourseForUser } from 'app/_models/training/training-course-for-user.model';
import { TrainingSectionType } from 'app/_models/training/training-section-type';
import { NotificationService } from 'app/_services/notification.service';
import { TrainingService } from 'app/_services/training.service';


@Component({
  selector: 'training-overview',
  templateUrl: './training-overview.component.html',
})
export class TrainingOverviewComponent implements OnInit {
  public workerUserCourseId: number;
  public routeRole: any;
  public nextSection: TrainingCourseSection;

  public trainingCourse: TrainingCourseForUser;

  public sectionLink = 'training';
  public userCourseType = 'worker'
  public TrainingSectionType = TrainingSectionType; // allow enum in template
  public TrainingCourseSectionStateType = TrainingCourseSectionState; // allow enum in template

  constructor(
    private trainingService: TrainingService,
    private notificationService: NotificationService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private globals: Globals,
  ) {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.activatedRoute.queryParams.subscribe(queryParams => {
        if (queryParams['type'] === 'contractor') {
          this.workerUserCourseId = parseInt(params['userCourseId'], 10);
          this.userCourseType = 'contractor';
          this.sectionLink = 'outage-acceptance'
        } else {
          this.workerUserCourseId = parseInt(params['workerUserCourseId'], 10);
        }
      });
    });
    this.routeRole = globals.user.routeRole;
  }

  ngOnInit() {
    this.setupPage();
  }

  private setupPage() {
    this.trainingService.getTrainingCourseForWorkerById(this.workerUserCourseId).subscribe(trainingCourse => {
      this.trainingCourse = trainingCourse;
      this.nextSection = this.trainingCourse.getFirstIncompleteSection();
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Error', 'Could not load training data');
    });
  }
}
